<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.063.063h19.875v19.875H.063V.063z" />
    <path
      d="M1.91 10.75a1.647 1.647 0 01.42-2.05 1.258 1.258 0 011.77.184l.057.075 2.605 3.751V1.418a1.354 1.354 0 112.71 0v6.323a1.354 1.354 0 112.71 0v.903a1.354 1.354 0 112.71 0v.905a1.356 1.356 0 112.71 0v3.161c0 1.188-.277 2.361-.809 3.423-.987 2.303-3.356 3.716-5.742 3.8l-.296.005a6.626 6.626 0 01-5.859-3.531L1.91 10.75z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
